module.exports = __webpack_public_path__ + "img/fondo3.dcb472e8.png";